import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FormHandles, SubmitHandler } from '@unform/core';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Header,
  Input,
  Loading,
  Modal,
  Select,
} from '../../components';
import { ReactComponent as CancelIcon } from '../../assets/icons/cancel.svg';
import { ReactComponent as AceptIcon } from '../../assets/icons/acept.svg';
import { ReactComponent as HourIcon } from '../../assets/icons/hour.svg';
import { ReactComponent as CheckballIcon } from '../../assets/icons/checkball.svg';
import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg';
import { ReactComponent as PrinterIcon } from '../../assets/icons/printer.svg';
import api from '../../services/api';
import * as S from './styles';
import { useAuth } from '../../hooks/useAuth';
import { usePDFAssistanceData } from '../../hooks/usePDFAssistanceData';
import SwitchSigle from '../../components/SwitchSigle';

interface FormDataAssistance {
  os_number: number;
  os_control: string;
  register_by_name: string;
  page: number;
  limit: number;
}

interface IAssistance {
  id: number;
  open: Date;
  os_number: number;
  os_control: string;
  customer_id: number;
  customer: string;
  is_adaptation?: number;
  is_repair?: number;
  is_assistance?: number;
  assistance_type: string;
  request: string;
  technical_analysis?: string;
  procedures?: string;
  accept?: Date;
  cancel?: Date;
  register_by_id: number;
  register_by_name: string;
}

interface IAssistanceType {
  id: number;
  description: string;
}

/* interface ICustomerApi {
  id: number;
  name: string;
  description: string;
}
*/

interface IPreOS {
  id: number;
  os_number: string;
  created_at: string;
  customer_name: string;
  customer_contact: string;
  product: {
    description: string;
  };
  manufacturer: {
    name: string;
  };
  salesman: string;
  ophthalmologist: string;
  customer_certified_name: string;
  customer_certified_id: number;
  prevision?: string;
  status: string;
  register_by_name: string;
  esf_right_eye: number;
  cil_right_eye: number;
  eixo_right_eye: number;
  add_right_eye: number;
  dnp_right_eye: number;
  esf_left_eye: number;
  cil_left_eye: number;
  eixo_left_eye: number;
  add_left_eye: number;
  dnp_left_eye: number;
  horizontal: number;
  vertical: number;
  po: number;
  diagonal: number;
  height: number;
  model: string;
  frame: string;
  reference?: string;
  mounting: number;
  antiscratch: number;
  coloring: number;
  coloring_type?: string;
  antireflection: number;
  antireflection_type?: string;
  observations?: string;
  print_prisma: number;
  right_base: number;
  right_base_quantity: number;
  left_base: number;
  left_base_quantity: number;
  cliente_servico: string;
  codigo_cliente: number;
  numero: number;
}

const AssistanceOS = () => {
  const { setPdfAssistanceData } = usePDFAssistanceData();
  const { user } = useAuth();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [modalIsOpen, setShowModal] = useState(false);
  const [assistencia, setAssistencia] = useState<IAssistance[]>([]);
  const [totalAssistencia, setTotalAssistencia] = useState(0);
  const [osAdapter, setOsAdapter] = useState(false);
  const [osRepair, setOsRepair] = useState(false);
  const [osAssistance, setOsAssistance] = useState(false);
  const [assistanceTypes, setAssistanceTypes] = useState<IAssistanceType[]>([]);
  const [osNumber, setOsNumber] = useState(null);
  const [preOS, setPreOS] = useState<IPreOS | null>();
  const formRef = useRef<FormHandles>(null);
  const limit = 5;
  const visibleButtons = 5;
  const [totalPages, setTotalPages] = useState(
    Math.ceil(totalAssistencia / limit),
  );

  useEffect(() => {
    async function loadSelects() {
      const assistanceTypeResponse = await api.get('assistance-types');

      setAssistanceTypes(
        assistanceTypeResponse.data.map((obj: IAssistanceType) => ({
          label: obj.description,
          value: obj.description,
        })),
      );
    }

    loadSelects();
  }, []);

  const [filters, setFilters] = useState<FormDataAssistance>({
    os_number: 0,
    os_control: '',
    register_by_name: user.login,
    page: 1,
    limit,
  });

  const makePaginationText = useMemo(() => {
    const startItems =
      totalAssistencia >= filters.page
        ? filters.page * limit - limit + 1
        : totalAssistencia;
    let endItems =
      totalAssistencia >= limit ? filters.page * limit : totalAssistencia;
    endItems = endItems > totalAssistencia ? totalAssistencia : endItems;
    const text = `Mostrando ${startItems} até ${endItems} de ${totalAssistencia} registro(s)`;

    return text;
  }, [totalAssistencia, filters.page]);

  const calculateVisibleButtons = useCallback(() => {
    let maxLeft = filters.page - Math.floor(visibleButtons / 2);
    let maxRight = filters.page + Math.floor(visibleButtons / 2);
    const roundedTotalPages = Math.ceil(totalPages);

    if (maxLeft < 1) {
      maxLeft = 1;
      maxRight = visibleButtons;
    }

    if (maxRight > roundedTotalPages) {
      maxLeft = roundedTotalPages - (visibleButtons - 1);
      maxRight = roundedTotalPages;

      if (maxLeft < 1) maxLeft = 1;
    }

    return { maxLeft, maxRight };
  }, [filters.page, totalPages]);

  const goToPage = useCallback(
    (page: number) => {
      if (page > Math.ceil(totalPages)) return;

      setFilters({
        ...filters,
        page,
      });
    },
    [filters, totalPages],
  );

  const renderPageButtons = useMemo(() => {
    const { maxLeft, maxRight } = calculateVisibleButtons();
    // const isButtonDisabled = maxRight <= visibleButtons;
    const buttons = [];

    for (let page = maxLeft; page <= maxRight; page += 1) {
      buttons.push(
        <S.PageButton
          type="button"
          className={filters.page === page ? 'active' : ''}
          title={`Ver página ${page}`}
          key={`page${page}`}
          onClick={() => goToPage(page)}
        >
          {page}
        </S.PageButton>,
      );
    }

    return buttons;
  }, [calculateVisibleButtons, filters.page, goToPage]);

  const loadAssistanceOS = useCallback(
    async (selectedFilters?: FormDataAssistance) => {
      setIsLoading(true);
      try {
        const response = await api.get<{ data: IAssistance[]; total: number }>(
          'assistance',
          {
            params: {
              ...filters,
              ...selectedFilters,
            },
          },
        );

        setAssistencia(response.data.data);
        setTotalAssistencia(response.data.total);
        setTotalPages(response.data.total / limit);
      } catch (error) {
        toast.error('Não foi possível consultar os dados. Tente mais tarde.');
      } finally {
        setIsLoading(false);
      }
    },
    [filters],
  );

  useEffect(() => {
    loadAssistanceOS();
  }, [loadAssistanceOS]);

  const toggleModal = () => {
    setShowModal(oldState => !oldState);
    handleLimparDados();
  };

  const handleSearchOS = async () => {
    if (!osNumber) return;

    try {
      const response = await api.get(`/pre-os/customer/${osNumber}`, {
        params: {
          register_by: user.login,
        },
      });

      if (response.status === 400) {
        toast.info('400-Serviço indisponivel!');
      }

      if (response.status === 404) {
        toast.info('404-Serviço não encontrado!');
      }

      if (response.status === 401) {
        toast.info('401-Falha na requisição da chamada!');
      }

      if (response.status === 204) {
        toast.info('OS não encontrada!');
      }

      if (response.data) {
        setPreOS(response.data.data);
      }
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  const handleOsNumber = () => {
    setOsNumber(formRef.current?.getFieldValue('os_number'));
  };

  const handleOsAdapter = () => {
    setOsAdapter(formRef.current?.getFieldValue('is_adaptation') === 0);
    if (osAdapter === false) {
      setOsRepair(false);
      setOsAssistance(false);
    }
  };

  const handleOsRepair = () => {
    // console.log(formRef.current?.getFieldValue('is_repair'));
    setOsRepair(formRef.current?.getFieldValue('is_repair') === 0);
    if (osRepair === false) {
      setOsAdapter(false);
      setOsAssistance(false);
    }
  };

  const handleOsAssistance = () => {
    setOsAssistance(formRef.current?.getFieldValue('is_assistance') === 0);
    if (osAssistance === false) {
      setOsAdapter(false);
      setOsRepair(false);
    }
  };

  const handleOpenAssistancePDF = (selected: IAssistance) => {
    setPdfAssistanceData(selected);
    history.push(`${process.env.PUBLIC_URL}/assistance-pdf`);
  };

  const handleLimparDados = () => {
    if (modalIsOpen === false) {
      setPreOS(null);
      setOsAdapter(false);
      setOsRepair(false);
      setOsAssistance(false);
      formRef.current?.getFieldValue('request').setValue('');
      formRef.current?.getFieldValue('customer').setValue('');
      formRef.current?.getFieldValue('os_number').setValue('');
    }
  };

  const handleAssistanceSubmit: SubmitHandler<FormData> = async data => {
    if (isLoading) return;

    /* if (osAdapter && !osAssistance && !osRepair) {
      toast.error('Você só pode escolher uma opção de assistência!');
      return;
    }

    if (!osAdapter && osAssistance && !osRepair) {
      toast.error('Você só pode escolher uma opção de assistência!');
      return;
    }

    if (!osAdapter && !osAssistance && osRepair) {
      toast.error('Você só pode escolher uma opção de assistência');
      return;
    } */

    setIsLoading(true);
    formRef.current?.setErrors({});

    Object.assign(data, {
      open: new Date(),
      os_number: preOS?.numero,
      os_control: formRef.current?.getFieldValue('os_number'),
      customer_id: preOS?.codigo_cliente,
      customer: formRef.current?.getFieldValue('customer'),
      is_adaptation: osAdapter === true ? 1 : 0,
      is_repair: osRepair === true ? 1 : 0,
      is_assistance: osAssistance === true ? 1 : 0,
      assistance_type: formRef.current?.getFieldValue('assistance_type'),
      request: formRef.current?.getFieldValue('request'),
      register_by_id: user.id,
      register_by_name: user.login,
    });

    try {
      const response = await api.post('assistance', data);

      if (response.status === 201) {
        toast.success('Solicitação de assitência técnica criada com sucesso.');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setShowModal(false);
        handleLimparDados();
      }
    } catch (error: any) {
      if (error?.response?.status === 401) {
        toast.error(
          'Erro na validação dos dados! Não foi possível criar a solicitação de assitência técnica',
        );
        return;
      }

      if (error?.response?.status === 400) {
        toast.error(
          'Não foi possível criar a solicitação de assitência técnica',
        );
        return;
      }

      toast.error('Não foi possível processar sua solicitação');
    } finally {
      setIsLoading(false);
      loadAssistanceOS();
    }
  };

  return (
    <>
      <Header />
      <S.Container>
        <S.InputColumnGroupGrid cols={6}>
          <Button
            title="Atualizar lista"
            text="Atualizar"
            onClick={() => loadAssistanceOS()}
          />
          <Button
            title="Lançar nova assistência"
            text="Gerar Novo"
            onClick={toggleModal}
          />
        </S.InputColumnGroupGrid>

        <S.TableHeader>
          <span>Número da OS</span>
          <span>Cliente</span>
          <span>Solicitação</span>
          <span>Aberto</span>
          <span>Adapt.</span>
          <span>Conse.</span>
          <span>Assis.</span>
          <span>Tipo</span>
          <span>Status</span>
          <span> </span>
        </S.TableHeader>

        <S.TableBody>
          {isLoading ? (
            <S.EmptyContent>
              <Loading color="#aaa" />
            </S.EmptyContent>
          ) : (
            <>
              {assistencia.length > 0 ? (
                assistencia.map(row => (
                  <S.TableRow key={row.id}>
                    <span>{row.os_number}</span>
                    <span>{row.customer}</span>
                    <span>{row.request}</span>
                    <span>{new Date(row.open).toLocaleString('pt-BR')}</span>
                    <span>
                      {Number(row.is_adaptation) === 1 ? (
                        <CheckballIcon
                          width="20"
                          height="20"
                          title="Adaptação"
                        />
                      ) : (
                        <></>
                      )}
                    </span>
                    <span>
                      {Number(row.is_repair) === 1 ? (
                        <CheckballIcon
                          width="20"
                          height="20"
                          title="Conserto"
                        />
                      ) : (
                        <></>
                      )}
                    </span>
                    <span>
                      {Number(row.is_assistance) === 1 ? (
                        <CheckballIcon
                          width="20"
                          height="20"
                          title="Assistência"
                        />
                      ) : (
                        <></>
                      )}
                    </span>
                    <span>{row.assistance_type}</span>
                    <S.IconsContainer>
                      {!row.cancel && !row.accept ? (
                        <HourIcon width="20" height="20" title="Aguardando" />
                      ) : (
                        <></>
                      )}

                      {row.cancel ? (
                        <CancelIcon width="20" height="20" title="Indeferida" />
                      ) : (
                        <></>
                      )}

                      {row.accept ? (
                        <AceptIcon width="20" height="20" title="Aceite" />
                      ) : (
                        <></>
                      )}
                      <PrinterIcon
                        width="20"
                        height="20"
                        title="Imprimir"
                        onClick={() => handleOpenAssistancePDF(row)}
                      />
                    </S.IconsContainer>
                  </S.TableRow>
                ))
              ) : (
                <S.EmptyContent>Nenhuma informação encontrada</S.EmptyContent>
              )}
            </>
          )}
        </S.TableBody>

        <S.PaginationContainer>
          <span>{makePaginationText}</span>
          <S.PageButtonsContainer>{renderPageButtons}</S.PageButtonsContainer>
        </S.PaginationContainer>

        <Modal modalIsOpen={modalIsOpen} setShowModal={setShowModal} size="md">
          <Form ref={formRef} onSubmit={handleAssistanceSubmit}>
            <h3>Qual solicitação?</h3>
            <S.RowsGrid>
              <S.InputColumnGroupGrid cols={3}>
                <SwitchSigle
                  label="Adaptação"
                  name="is_adaptation"
                  checked={osAdapter}
                  onChange={handleOsAdapter}
                  disabled={false}
                />
                <SwitchSigle
                  label="Conserto"
                  name="is_repair"
                  checked={osRepair}
                  onChange={handleOsRepair}
                  disabled={false}
                />
                <SwitchSigle
                  label="Assistência Técnica"
                  name="is_assistance"
                  checked={osAssistance}
                  onChange={handleOsAssistance}
                  disabled={false}
                />
              </S.InputColumnGroupGrid>
              <S.InputColumnGroupGrid cols={2}>
                <Input
                  label="Número da OS"
                  name="os_number"
                  type="text"
                  onChange={handleOsNumber}
                />
                <Button
                  text={<SearchIcon width="20" height="20" />}
                  title="Consultar OS"
                  onClick={handleSearchOS}
                />
              </S.InputColumnGroupGrid>
              <Input
                label="Cliente"
                name="customer"
                type="text"
                value={preOS?.cliente_servico}
                disabled
              />
              <Select
                label="Tipo da Assistência"
                name="assistance_type"
                options={assistanceTypes}
                isDisabled={!osAssistance}
              />
              <Input
                label="Solicitação"
                name="request"
                multiline
                title="Informações para assistência técnica"
                containerStyle={{
                  marginTop: 'auto',
                }}
              />
              <Button
                text="Enviar solicitação"
                type="submit"
                containerStyle={{ marginTop: '1rem' }}
              />
            </S.RowsGrid>
          </Form>
        </Modal>
      </S.Container>
    </>
  );
};

export default AssistanceOS;
